import React, { useEffect, useState } from 'react';
import { useQuery } from '@apollo/client';
import { useRef } from 'react';
import { Text,MixedGridGroup,NotificationList } from 'quanta-ui';

import QuoteData from './quote-data';

import {
  APPLICABLE_COVERS,
  CHARACTER_LIMIT_LIST,
  GET_FIELDUSER_LIST,
  GET_TWO_WHEELER_POLICY_VAR_DETAILS,
  GET_SEGMENT_ADDON,
  INSURED_DECLARED_VALUE,
  GET_IRT2_ROLE_LIMIT,
  FETCH_ROLE
} from '../../queries';
import {Loading} from 'quanta-flows/modules/layout';
import {Error} from 'quanta-flows/modules/layout';
import CoversForm from './covers-form';
//import useFetchQuery from './lib/graphql/useFetchCacheQuery';
import { useFetchQuery } from 'quanta-flows';
import { updateMotorQuote } from 'quanta-flows/modules/quote/motor/state';
export default function Covers({
  goToStep,
  productCode,
  productName,
  lobCode,
  quoteNumber,
  lobName,
  modify,
  ...props
}) {
  const fetchQuery = useFetchQuery();
  const [loadingCovers, setLoadingCovers] = useState(false);
  const [errorCovers, setErrorCovers] = useState(null);
  const [coversInfo, setCoversInfo] = useState(null);
  const [initLoad, setInitLoad] = useState(true);
  const [fieldUserList, setFieldUserList] = useState([]);
  const [loadingIDVValues, setLoadingIDVValues] = useState(false);
  const [errorIDVValues, setErrorIDVValues] = useState(null);
  const [idvValues, setIdvValues] = useState(null);
  const[irflimitvalue,setirflimitvalue]=useState([]);
  const [motorQuoteData, setMotorQuoteData] = useState(null);
  const [skip, setSkip] = useState(false);
  const[showCalculatePremiumButtonIDV,setshowCalculatePremiumButtonIDV]  = useState(false);
  const updatedidvvalues = useRef();
    const CoverInfoRef = useRef();
  const [calcPremOnLoad, SetCalcPremOnLoad] = useState(false);  
const {
  loading: loadingIrf2limits,
  error: errorIrf2limits,
  data: dataIrf2limits,
} = useQuery(GET_IRT2_ROLE_LIMIT, {
  fetchPolicy: 'network-only',
  //skip: !initLoad,
  onCompleted:(data)=> {
    setirflimitvalue(data)
  }
});
const { loading: loadingRoleData, data: dataRole } = useQuery(
  FETCH_ROLE,
  {
    fetchPolicy: 'cache-first',
  },
);
    const {
      loading: loadingMotorQuote,
      error: errorMotorQuote,
      data: dataMotorQuote,
      previousData: previousDataMotorQuote,
    } = useQuery(GET_TWO_WHEELER_POLICY_VAR_DETAILS, {
      fetchPolicy: 'cache-and-network',
      skip: !initLoad,
      onCompleted: async (data) => {
        const { motorQuote, selectedIntermediary } = data;
      setMotorQuoteData(data);
        try {
          SetCalcPremOnLoad(motorQuote?.calculatePremiumOnLoad
            ? true : false); /** display the proposal on load while propsoal Modify */
          setErrorCovers(null);
          const applicableCoversQuery = fetchQuery({
            query: APPLICABLE_COVERS,
            fetchPolicy: 
            data?.motorQuote?.quotationNo
              ? 'cache-first'
              : 
              'network-only',
            variables: {
              input: {
                productCode : motorQuote?.productCode
                  ? motorQuote?.productCode
                  : motorQuote?.productVariant?.toLowerCase()?.search('comprehensive') !== -1
                    ? '3121'
                    : motorQuote?.productVariant?.toLowerCase()?.search('liability') !== -1
                      ? '3176'
                      : motorQuote?.productVariant?.toLowerCase()?.search('od') !== -1
                        ? '3151'
                        : '3121',
                productType: data?.motorQuote?.productType,
                intermediaryCode:
                  data?.selectedIntermediary?.intermediaryCode,
                fuelType: data?.motorQuote?.fuelType,
              },
            },
          });
          const getFieldUserList = fetchQuery({
            query: GET_FIELDUSER_LIST,
            variables: {
              input: {
                intermediaryCode: (motorQuote?.intermediaryDetails?.code || selectedIntermediary?.intermediaryCode),
                officeId: (motorQuote?.intermediaryDetails?.location || selectedIntermediary?.branchOfficeCode)
              }
            }
          });
          setLoadingCovers(true);
          const { data: coversData } = await applicableCoversQuery;
          const { data: dataFieldUserList } = await getFieldUserList;
          setInitLoad(false);
          setFieldUserList(dataFieldUserList?.getFiledUserByIMID);
          setLoadingCovers(false);
          if( productCode?.toString() === '3121' 
              && (motorQuote?.businessType?.toLowerCase() === 'new business'
              || motorQuote?.businessTypeValue?.toLowerCase() === 'new business')){
                let modifyCoversData = {applicableCovers: {
                   riskCovers: coversData?.applicableCovers?.riskCovers?.map((cover) => {
                    return {
                         riskType : cover?.riskType,
                          covers: cover?.covers?.filter((e) => e?.name !== 'NCB Protect')
                          }
                    })
           }
         }
            setCoversInfo(modifyCoversData);
            CoverInfoRef.current = modifyCoversData;
         }else{
            setCoversInfo(coversData);
            CoverInfoRef.current = coversData;
         }
        } catch (error) {
          setLoadingCovers(false);
          setErrorCovers(error?.message);
        }
      },
    });
  let isMounted = true;
  if (
    isMounted &&
    (dataMotorQuote?.motorQuote?.quotationNo === '' 
    || dataMotorQuote?.motorQuote?.isProposalModify )
  ) {
    const {
      loadingIDV, errorIdv, dataIdv
    } = fetchQuery({
      query: INSURED_DECLARED_VALUE,
      fetchPolicy: 'cache-first',
      skip: !initLoad,
      variables: {

        input: {
          makeCode: dataMotorQuote?.motorQuote?.make?.code,
          varientCode: dataMotorQuote?.motorQuote?.variant?.code,
          rtoCode: dataMotorQuote?.motorQuote?.rtoLocationCode,
          imdCode:
            dataMotorQuote?.selectedIntermediary
              ?.intermediaryCode ||
            dataMotorQuote?.motorQuote?.intermediaryDetails?.code,
          dateOfReg: dataMotorQuote?.motorQuote?.dateOfReg,//SAIDVissue
          productCode: productCode,
          businessType: dataMotorQuote?.motorQuote?.businessType,
          pastPolicyExpDate: dataMotorQuote?.motorQuote?.anyPreviousPolicyforVehicleTaken
            ?.toString()?.toLowerCase() === 'yes'
            ? dataMotorQuote?.motorQuote?.policyExpiryDate : null
        },
      },
    })
      ?.then((response) => {
        setInitLoad(false);
        if (isMounted) {
          const { data: idvData } = response;
          // updateMotorQuote({
          //   ...motorQuote,
          //   changedIDV:idvData?.insuredDeclaredValue?.suggestedIDV,
          //   suggestedIDV:idvData?.insuredDeclaredValue?.suggestedIDV,
          //   minSuggestedIDV:idvData?.insuredDeclaredValue?.minSuggestedIDV,
          //   maxSuggestedIDV:idvData?.insuredDeclaredValue?.maxSuggestedIDV,
          //   idvPctMin:idvData?.insuredDeclaredValue?.idvPctMin,
          //   idvPctMax:idvData?.insuredDeclaredValue?.idvPctMax,
          // })
          setIdvValues(idvData);   
          setInitLoad(false);             
          setLoadingIDVValues(false);

          return response;
       }
        }
      )
      ?.catch((error) => {
        if (isMounted) {
          setLoadingIDVValues(false);
          setInitLoad(false);             
          setErrorIDVValues(error?.message);
          isMounted = false;
        }
        return error;
      });
      if (loadingIDVValues) {
        return (
          <div className="min-h-full">
            <Loading
              textSize={repeat === repeatForMobile ? 'normal' : undefined}
              customMessage={'Fetching insured declared value details'}
            />
          </div>
        );
      }
    }
  useEffect(() => {
    
    const segmentAddOnCovers = async () => {
        try {
         setLoadingCovers(true);
         const getsegmentAddOnQuery = fetchQuery({
          query: GET_SEGMENT_ADDON,
          fetchPolicy:'network-only',
          variables: {
            input: {
              segmentType: motorQuoteData?.motorQuote?.segmentType || '',
              vehicleAge: idvValues?.insuredDeclaredValue?.vehicleAge || ''
            }
          }
        });
        setLoadingCovers(true);
        const { data: dataSegmentAddOn } = await getsegmentAddOnQuery;
        const { getSegmentAddOn } = dataSegmentAddOn;
        let KgiAddOn = [  'N093891G0111',  'N093891G0104',   'N093891G0045',  'N093891G0100', 'N093891G0099', 'N093891G0043', 'N093891G0101',  'N093891G0102', 'N093891G0090', 'N093891G0088', 'N093891G0087','N464403G0087', 'N464403G0113','N464403G0100','N464403G0099','N464403G0043','N464403G0101', 'N464403G0102','N464403G0090','N464403G0088','N464403G0043','N464403G0103','N464403G0045' ,
        "N093891G0103", "N093891G0107" ,"N464403G0105" ,"N093891G0108", "N464403G0106", "N093891G0106", "N464403G0104", "N093891G0105", "N093891G0110", "N464403G0108", "N093891G0113", "N464403G0115", "N464403G0116", "N093891G0114", "N464403G0107", 
        ];
        let modifyCoversData = {
          applicableCovers: {
            riskCovers: CoverInfoRef.current?.applicableCovers?.riskCovers?.map((cover) => {
              return {
                riskType: cover?.riskType,
                covers: cover?.covers?.map((cov) => {
                  return {
                    disabled: (getSegmentAddOn?.AddOnList !== null &&
                      getSegmentAddOn?.AddOnList?.length > 0 
                      && KgiAddOn?.find((d) => cov?.index === d) )
                     ?  ( getSegmentAddOn?.AddOnList?.find(
                        (e) => cov?.name?.toString()?.toLowerCase() === e?.toString()?.toLowerCase()))
                        ? false : true
                      : false,
                    ...cov,
                  };
                })?.filter((d) => d)
              }
            })
          }
        }
        setCoversInfo(modifyCoversData);
        CoverInfoRef.current = modifyCoversData;
        setLoadingCovers(false);
        setSkip(true);
        } catch (error) {
         setLoadingCovers(false);
         setErrorCovers(error?.message);
        }
    }
    if( !skip && idvValues && CoverInfoRef.current && motorQuoteData
      && !(motorQuoteData?.motorQuote?.quotationNo)) {
      segmentAddOnCovers();
    }
    
  },[idvValues,CoverInfoRef,coversInfo, motorQuoteData,skip]);
  const {
    loading: loadingNameLimit,
    error: errorNameLimit,
    data: dataNameLimit,
    previousData: previousDataNameLimit
  } = useQuery(CHARACTER_LIMIT_LIST, {
    fetchPolicy: 'catch-and-network',
    skip: !initLoad
  });
  const {
    loading: loadingMotorQuote1,
    error: errorMotorQuote1,
    data: dataMotorQuote1,
    previousData: previousdataMotorQuote1
  } = useQuery(GET_TWO_WHEELER_POLICY_VAR_DETAILS, {
    fetchPolicy: 'cache-and-network',
     skip: !initLoad
  }); 

  if (loadingCovers || loadingMotorQuote || loadingNameLimit||loadingMotorQuote1||loadingIDVValues||loadingIrf2limits||loadingRoleData)
    return (
      <div className="min-h-screen">
        <Loading
          customMessage={
            quoteNumber ? 'Loading' : 'Looking for applicable covers'
          }
        />
      </div>
    );
  if (errorCovers || errorMotorQuote || errorNameLimit) {
    let error = {
      message: `There was an issue fetching the applicable covers. Please try again after some time...`,
    };
    return <Error error={error} />;
  }

  const { motorQuote, selectedIntermediary } = dataMotorQuote1
    ? dataMotorQuote1
    : previousdataMotorQuote1;
  const { characterLimitList } = dataNameLimit ? dataNameLimit: previousDataNameLimit;
  const role = dataRole?.checkAuth?.role?.roleName;


  return coversInfo && coversInfo?.applicableCovers ? (   
    <div>
      <QuoteData
        goToStep={goToStep}
        forwardedCoversFormRef={props?.forwardedCoversFormRef}
        lobCode={lobCode}
        lobName={lobName}
        quoteNumber={quoteNumber}
        productCode={productCode}
        productName={productName}
        idvValues={idvValues}
        setshowCalculatePremiumButtonIDV={setshowCalculatePremiumButtonIDV}
        showCalculatePremiumButtonIDV={showCalculatePremiumButtonIDV}
        updatedidvvalues={updatedidvvalues}
        modify={modify}
        irflimitvalue={irflimitvalue}
        dataRole={role}
        imdcode={motorQuote?.intermediaryDetails?.code || selectedIntermediary?.intermediaryCode}
      />
      <div className="mt-6">
        <Text type="title" severity="info">
          We have found below covers for your selection
        </Text>
      </div>
      <div className="mt-2">
        <CoversForm
          tenureList={coversInfo?.applicableCovers?.tenure}
          riskCovers={coversInfo?.applicableCovers?.riskCovers}
          productCode={productCode}
          productName={productName}
          lobCode={lobCode}
          lobName={lobName}
          quoteNumber={quoteNumber}
          motorQuote={motorQuote}
          selectedIntermediary={selectedIntermediary}
          fieldUserList={fieldUserList}
          characterLimitList={characterLimitList}
          forwardedCoversFormRef={props?.forwardedCoversFormRef}
          modify={modify}
          showCalculatePremiumButtonIDV={showCalculatePremiumButtonIDV}
          setshowCalculatePremiumButtonIDV={setshowCalculatePremiumButtonIDV}
          updatedidvvalues={updatedidvvalues}
          calcPremOnLoad={calcPremOnLoad}
          SetCalcPremOnLoad={SetCalcPremOnLoad}
          idvValues={idvValues}
        />
      </div>
    </div>
    
  ) : null;
  
}
